import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@chakra-ui/react';

import type { ApiAcceptedLanguage } from '@izimi/api';
import { useTracking } from '@izimi/components';
import { getLanguageString } from '@izimi/core';
import { TrackingEventAction, TrackingEventCategory } from '@izimi/modules';

const acceptedLanguages: Array<ApiAcceptedLanguage> = ['de', 'en', 'fr', 'nl'];

export const LanguageSelector = () => {
  const {
    i18n: { changeLanguage, language },
  } = useTranslation();
  const { trackEvent } = useTracking();

  const onLanguageChange = (e: ChangeEvent<HTMLSelectElement>) => {
    trackEvent({
      category: TrackingEventCategory.General,
      action: TrackingEventAction.LanguageSelectionUpdated,
    });
    changeLanguage(e.currentTarget.value);
  };

  return (
    <Select onChange={onLanguageChange} value={language} variant='languageSelector'>
      {acceptedLanguages.map((key) => (
        <option value={key} key={key}>
          {getLanguageString(key)}
        </option>
      ))}
    </Select>
  );
};
